import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../services/redux/hooks/hooks";

export const Landing = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState<any>(null);

  const userDetails = useAppSelector((state) => {
    return state.user;
  });

  useEffect(() => {
    if (userDetails.userCommArray.length) {
      if (
        userDetails.userCommArray.includes("Copper Wire") &&
        userDetails.userCommArray.length === 1
      ) {
        navigate("/wirecontracts");
      } else {
        navigate("/home");
      }
    }
  }, [userDetails.userCommArray]);

  useEffect(() => {
    if (window.localStorage.getItem("userEmail")) {
      setEmail(window.localStorage.getItem("userEmail"));
    }
  }, [window.localStorage.getItem("userEmail")]);

  return null;
};
